module.exports = __webpack_public_path__ + "static/media/cti.45999614.svg";